import { ReactNode } from 'react';
import { Card as BootstrapCard } from 'react-bootstrap';

interface PropsType {
  children: ReactNode;
  variant?: 'primary' | 'white' | 'info' | 'danger' | 'light' | 'transparent';
  className?: string;
  onClick?: () => void;
}

const Card = ({ children, variant='primary', className='', onClick }: PropsType) => {
  const newClassName = `${className} ${variant == 'transparent' ? 'opacity-0 shadow-none' : ''}`

  return(
    <BootstrapCard bg={variant} style={{ padding: '20px' }} className={newClassName} onClick={onClick}>
      {children}
    </BootstrapCard>
  )
}

export default Card;
